import type { Feature } from '@/shared/registry'

/** A developer and design reference with no data, so it is public. */
export const feature: Feature = {
  id: 'ui-gallery',
  routes: [
    {
      path: '/ui-gallery',
      titleId: 'uiGallery.title',
      page: () => import('./UiGalleryPage').then((module) => module.UiGalleryPage),
      public: true,
    },
    {
      path: '/ui-gallery/rich-text',
      titleId: 'uiGallery.richText.title',
      page: () => import('./RichTextGalleryPage').then((module) => module.RichTextGalleryPage),
      public: true,
    },
  ],
}
